var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AsiCardDetail',{attrs:{"icon":_vm.icons.category,"title":_vm.$t('ui.terms.canonical')}},[_c('AsiCardDetailEntryTranslatedValue',{attrs:{"icon":_vm.icons.canonical,"label":_vm.$t('ui.terms.canonical'),"value":_vm.category.canonical}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }